import buildTask from '@coorpacademy/redux-task';
import {constant} from 'lodash/fp';
import {getProgressionContent, getCurrentContent, getNextContent} from '../../utils/state-extract';

export const LOCATION_RETRY_REQUEST = '@@location/RETRY_REQUEST';
export const LOCATION_RETRY_SUCCESS = '@@location/RETRY_SUCCESS';
export const LOCATION_RETRY_FAILURE = '@@location/RETRY_FAILURE';

export const retry = (dispatch, getState, {services}) => {
  const {ref: contentRef} = getProgressionContent(getState());

  const action = buildTask({
    types: [LOCATION_RETRY_REQUEST, LOCATION_RETRY_SUCCESS, LOCATION_RETRY_FAILURE],
    task: () => services.Location.retry(contentRef),
    meta: {contentRef}
  });

  return dispatch(action);
};

export const LOCATION_EXIT_REQUEST = '@@location/EXIT_REQUEST';
export const LOCATION_EXIT_SUCCESS = '@@location/EXIT_SUCCESS';
export const LOCATION_EXIT_FAILURE = '@@location/EXIT_FAILURE';

export const exit = (dispatch, getState, {services}) => {
  const action = buildTask({
    types: [LOCATION_EXIT_REQUEST, LOCATION_EXIT_SUCCESS, LOCATION_EXIT_FAILURE],
    task: () => services.Location.exit()
  });

  return dispatch(action);
};

export const LOCATION_BACK_REQUEST = '@@location/BACK_REQUEST';
export const LOCATION_BACK_SUCCESS = '@@location/BACK_SUCCESS';
export const LOCATION_BACK_FAILURE = '@@location/BACK_FAILURE';

export const back = (dispatch, getState, {services}) => {
  const content = getCurrentContent(getState());
  const action = buildTask({
    types: [LOCATION_BACK_REQUEST, LOCATION_BACK_SUCCESS, LOCATION_BACK_FAILURE],
    task: () => services.Location.back(content)
  });

  return dispatch(action);
};

export const LOCATION_SEE_COMMENT_REQUEST = '@@location/SEE_COMMENT_REQUEST';
export const LOCATION_SEE_COMMENT_SUCCESS = '@@location/SEE_COMMENT_SUCCESS';
export const LOCATION_SEE_COMMENT_FAILURE = '@@location/SEE_COMMENT_FAILURE';

export const seeComment = (dispatch, getState, {services}) => {
  const content = getCurrentContent(getState());
  const action = buildTask({
    types: [
      LOCATION_SEE_COMMENT_REQUEST,
      LOCATION_SEE_COMMENT_SUCCESS,
      LOCATION_SEE_COMMENT_FAILURE
    ],
    task: () => services.Location.seeComment(content)
  });

  return dispatch(action);
};

export const LOCATION_NEXT_CONTENT_REQUEST = '@@location/LOCATION_NEXT_CONTENT_REQUEST';
export const LOCATION_NEXT_CONTENT_SUCCESS = '@@location/LOCATION_NEXT_CONTENT_SUCCESS';
export const LOCATION_NEXT_CONTENT_FAILURE = '@@location/LOCATION_NEXT_CONTENT_FAILURE';

export const nextLevel = (dispatch, getState, {services}) => {
  const nextContent = getNextContent(getState());

  if (nextContent) {
    const action = buildTask({
      types: [
        LOCATION_NEXT_CONTENT_REQUEST,
        LOCATION_NEXT_CONTENT_SUCCESS,
        LOCATION_NEXT_CONTENT_FAILURE
      ],
      task: () => services.Location.nextLevel(nextContent.ref)
    });

    return dispatch(action);
  }
};

export const LOCATION_OPEN_RECOMMENDATION_REQUEST =
  '@@location/LOCATION_OPEN_RECOMMENDATION_REQUEST';
export const LOCATION_OPEN_RECOMMENDATION_SUCCESS =
  '@@location/LOCATION_OPEN_RECOMMENDATION_SUCCESS';
export const LOCATION_OPEN_RECOMMENDATION_FAILURE =
  '@@location/LOCATION_OPEN_RECOMMENDATION_FAILURE';

export const openRecommendation =
  recommendation =>
  (dispatch, getState, {services}) => {
    if (!services.Location.openRecommendation) {
      return;
    }
    const action = buildTask({
      types: [
        LOCATION_OPEN_RECOMMENDATION_REQUEST,
        LOCATION_OPEN_RECOMMENDATION_SUCCESS,
        LOCATION_OPEN_RECOMMENDATION_FAILURE
      ],
      task: () => services.Location.openRecommendation(recommendation)
    });

    return dispatch(action);
  };

export const SET_REDIRECT_URL_AFTER_END_REQUEST = '@@location/SET_REDIRECT_URL_AFTER_END_REQUEST';
export const SET_REDIRECT_URL_AFTER_END_SUCCESS = '@@location/SET_REDIRECT_URL_AFTER_END_SUCCESS';
export const SET_REDIRECT_URL_AFTER_END_FAILURE = '@@location/SET_REDIRECT_URL_AFTER_END_FAILURE';

export const setRedirectUrlEnd = constant((dispatch, getState, {services}) => {
  const action = buildTask({
    types: [
      SET_REDIRECT_URL_AFTER_END_REQUEST,
      SET_REDIRECT_URL_AFTER_END_SUCCESS,
      SET_REDIRECT_URL_AFTER_END_FAILURE
    ],
    task: () => services.Location.getRedirectURLAfterEnd()
  });
  return dispatch(action);
});
